import { useAuth0 } from "@auth0/auth0-react";
import MyTable from "components/Table";
import AuthService from "Lib/API/Auth";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import "./index.scss";

const ParticipantsTable = ({ member,setForm }) => {
  const [loading, setLoading] = React.useState(false);
  const [list, setList] = React.useState([]);
  const [part, setPart] = React.useState([]);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [col, setCol] = useState([]);

  const { getAccessTokenSilently } = useAuth0();
  const history = useHistory();
  const enableLoading = (value) => {
    setLoading(value);
  };
  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      const idLength = history.location.pathname?.split("/").length;
      const classId = history?.location?.pathname?.split("/")[idLength - 1];
      const accountId = history?.location?.pathname?.split("/")[2];
      if (classId === accountId) {
        await AuthService.getParticipants(classId, token)
          .then((res) => {
            setList(res?.class_form_fields);
            if (res.participants.length !== 0) {
              res.participants.map((item) => {
                item.id = item._id;
                return item;
              });
              setPart(res.participants);
              setForm(res.class_form_fields)
            } else setList([]);
            enableLoading(false);
          })
          .catch((err) => {
            enableLoading(false);
            toastr.error("Error", err?.data?.message);
          });
      } else {
        await AuthService.getParticipantsByAccount(
          `${accountId}/${classId}`,
          token
        )
          .then((res) => {
            setList(res?.class_form_fields);
            if (res.participants.length !== 0) {
              res.participants.map((item) => {
                item.id = item._id;
                return item;
              });
              setPart(res.participants);
            } else setList([]);
            enableLoading(false);
          })
          .catch((err) => {
            enableLoading(false);
            toastr.error("Error", err?.data?.message);
          });
      }
    }
    fetchMyAPI();
    enableLoading(true);
  }, [getAccessTokenSilently]);

  useEffect(() => {
    const columns = list.map((item, index) => {
      return {
        field: index,
        headerName: item.fldDisplay,
        width: 150,
        renderCell: (data) => {
          return (
            <div className="user-cotainer-home">
              {item.fldInputType === "upload" ? (
                <a
                  target="_blank"
                  href={data?.row?.form_fields[index]}
                  style={{ textDecoration: "underline" }}
                >
                  Link
                </a>
              ) : (
                data?.row?.form_fields[index]
              )}
            </div>
          );
        },
      };
    });
    setCol(columns);
  }, [list]);
  const moreCol = [
    ...col,
    {
      field: "payment",
      headerName: "Payment status",
      width: 130,
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home">{data?.row?.payment?.status}</div>
        );
      },
    },
  ];
  return (
    <>
      <div className="current-class-table-container">
        <MyTable
          rows={part}
          columns={col.length === 0 ? [] : moreCol}
          pageSize={7}
          loading={loading}
          className="class-table"
          checkboxSelection
          disableSelectionOnClick
          onSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }}
          selectionModel={selectionModel}
        >
          Rows per page: {7}
        </MyTable>
      </div>
    </>
  );
};

export default ParticipantsTable;
